import { app } from '../../app.module'
app
  // アカウントのコメントグラフの表示
  .directive('accountComment', () => {
    return {
      restrict: 'E',
      template: require('./account-comment.pug')(),
    }
  })
